import React, { useState } from "react";
import "./TextBox.scss";

const TypeHead = ({
  type = "text", // type
  name = "", // name for form
  value = "", // value
  size = "md", // size variant
  widthSize, // width size
  disabled = false, // disable or not
  suggestions = [], // add data which can search when type
  icon: Icon = null, // icon add to type head
  iconSide = "left", // if icon is set then in which side to place
  className = "",
  placeholder = "",
  onChange,
  ...props
}) => {
  /* useStates */
  const [inputValue, setInputValue] = useState(value); // store input value
  const [filteredSuggestions, setFilteredSuggestions] = useState([]); // store matched suggestion
  const [showSuggestions, setShowSuggestions] = useState(false); // show the suggestion on type
  /* end useStates */

  const handleChange = (e) => {
    const userInput = e.target.value;
    setInputValue(userInput);
    onChange?.(e);

    if (userInput) {
      const filtered = suggestions.filter((s) =>
        s.toLowerCase().startsWith(userInput.toLowerCase())
      );
      setFilteredSuggestions(filtered);
      setShowSuggestions(true);
    } else {
      setShowSuggestions(false);
    }
  }; // handel suggestion search and show the shorted suggestion

  const handleSuggestionClick = (suggestion) => {
    setInputValue(suggestion);
    setShowSuggestions(false);
    onChange?.({ target: { name, value: suggestion } }); // Emulate native event
  }; // handle on suggestion click select clicked suggestion

  const prenetClasses = `borderWrapper ${className} ${
    Icon &&
    ((iconSide?.toLowerCase() === "left" && "iconLeft") ||
      (iconSide?.toLowerCase() === "right" && "iconRight"))
  } ${disabled ? "disabled" : ""}`; // parent classes of type head
  const classes = `input typeahead borderInner ${size} ${
    widthSize ? "Width-" + widthSize : ""
  } ${disabled ? "disabled" : ""}`; // type head classes

  return (
    <div
      className={`typeahead-container ${
        Icon &&
        ((iconSide?.toLowerCase() === "left" && "iconLeft") ||
          (iconSide?.toLowerCase() === "right" && "iconRight"))
      } ${size}`}
    >
      <div className={prenetClasses}>
        <input
          type={type}
          className={classes}
          name={name}
          placeholder={placeholder}
          value={inputValue}
          disabled={disabled}
          onChange={handleChange}
          autoComplete="off"
          {...props}
        />
        {Icon && <Icon size={size} className="input-icon" />}
      </div>
      {showSuggestions && filteredSuggestions.length > 0 && (
        <div className="typeahead-dropdown">
          <div className="borderWrapper">
            <div className="borderInner">
              <ul className="suggestions-list">
                {filteredSuggestions.map((suggestion, index) => (
                  <li
                    key={index}
                    onClick={() => handleSuggestionClick(suggestion)}
                    className="suggestions-list-items borderWrapperJustOneCorner"
                  >
                    {suggestion}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TypeHead;
